import type { AchievementI18N } from '../../../services/generated/Api';

export type Lang = 'ru' | 'en' | 'uz';

export function pickLang(): Lang {
  if (typeof document === 'undefined') return 'ru';
  const tag = document.documentElement.lang.toLowerCase();
  if (tag.startsWith('en')) return 'en';
  if (tag.startsWith('uz')) return 'uz';
  return 'ru';
}

export function pickTitle(i18n: AchievementI18N | undefined, lang: Lang = pickLang()): string {
  if (!i18n) return '';
  return i18n[lang]?.title ?? i18n.ru?.title ?? '';
}

export function pickDescription(i18n: AchievementI18N | undefined, lang: Lang = pickLang()): string {
  if (!i18n) return '';
  return i18n[lang]?.description ?? i18n.ru?.description ?? '';
}
